import axios from "@/utils/axios";
import { usePyConfig } from "./usePyConfig";

/**
 * 获取优惠券任务列表。
 * @param {{name?: string; start_date?: string; end_date?: string; per_page?: number; page?: number}} params 查询参数
 * @returns {Promise<{code: number; msg: string; data: {data: Array; total: number}}>} 优惠券任务分页数据
 */
export const getCouponList = params => {
  // 优惠券接口部署在 Python 服务，统一使用 Python 域名并自动携带 token、时间戳和签名。
  const config = usePyConfig("GET", "api/pandagpt/v1/coupon/list", params);
  return axios(...Object.values(config));
};

/**
 * 创建优惠券任务。
 * @param {FormData} formData 包含 name 与券码文件的表单数据
 * @returns {Promise<{code: number; msg: string; data: Array}>} 创建结果
 */
export const createCouponTask = formData => {
  // Python 创建接口接收 FormData，显式开启 multipart 标记避免文件被 JSON 序列化。
  const config = usePyConfig("POST", "api/pandagpt/v1/coupon/create", formData);
  config.isFormData = true;
  return axios(...Object.values(config));
};

/**
 * 获取优惠券任务详情。
 * @param {{task_id: string|number; start_date?: string; end_date?: string; status?: number; per_page?: number; page?: number}} params 详情查询参数
 * @returns {Promise<{code: number; msg: string; data: {data: Array; total: number}}>} 券码发送详情分页数据
 */
export const getCouponTaskDetail = params => {
  // 详情接口同样固定走 Python 服务，后续详情页或抽屉可以直接复用。
  const config = usePyConfig("GET", "api/pandagpt/v1/coupon/detail", params);
  return axios(...Object.values(config));
};

/**
 * 删除待发送的优惠券任务。
 * @param {{task_id: string|number}} params 待删除的任务 ID
 * @returns {Promise<{code: number; msg: string; data: Array}>} 删除结果
 */
export const deleteCouponTask = params => {
  // 删除接口部署在 Python 服务；后端会再次校验只有 status=0 的任务可以删除。
  const config = usePyConfig("POST", "api/pandagpt/v1/coupon/delete", params);
  return axios(...Object.values(config));
};